import React, { useState } from 'react';
import { useAuth } from '../components/AuthProvider.js';
import PixPaymentModal from '../components/PixPaymentModal.js';
import '../styles/ENEMTrainingPage.css';

const TestPixPaymentPage = () => {
  const { currentUser } = useAuth();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  // Mock user for testing
  const mockUser = currentUser || {
    uid: 'test-user-123',
    email: 'teste@example.com',
    displayName: 'Usuário Teste'
  };

  const handleTestPayment = () => {
    setShowPaymentModal(true);
  };

  const handlePaymentSuccess = () => {
    setPaymentSuccess(true);
    setShowPaymentModal(false);
    alert('Pagamento realizado com sucesso! A análise da redação será iniciada.');
  };

  return (
    <div className="enem-training-page" style={{ padding: '40px' }}>
      <h1>🧪 Teste de Integração PIX</h1>
      
      <div style={{ 
        background: '#f8f9fa', 
        padding: '30px', 
        borderRadius: '10px',
        marginBottom: '30px'
      }}>
        <h2>Informações do Sistema</h2>
        <p><strong>Usuário:</strong> {mockUser.displayName || 'Usuário Teste'}</p>
        <p><strong>Email:</strong> {mockUser.email}</p>
        <p><strong>ID:</strong> {mockUser.uid}</p>
        <p><strong>Valor da Análise:</strong> R$ 3,00</p>
      </div>

      {paymentSuccess && (
        <div style={{
          background: '#d4edda',
          color: '#155724',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '30px'
        }}>
          ✅ Pagamento confirmado! A análise da redação pode ser iniciada.
        </div>
      )}

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={handleTestPayment}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: '20px 40px',
            fontSize: '18px',
            fontWeight: 'bold',
            borderRadius: '10px',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
          }}
        >
          🚀 Testar Pagamento PIX
        </button>
      </div>

      <div style={{ 
        marginTop: '40px',
        padding: '20px',
        background: '#fff3cd',
        borderRadius: '10px'
      }}>
        <h3>📝 Notas sobre a Integração:</h3>
        <ul style={{ textAlign: 'left' }}>
          <li>O modal de pagamento PIX será exibido quando o usuário clicar em "Salvar e Analisar Redação"</li>
          <li>O pagamento de R$ 3,00 é único e libera a análise da redação</li>
          <li>Após o pagamento, a análise com IA é iniciada automaticamente</li>
          <li>O sistema verifica o status do pagamento a cada 5 segundos</li>
          <li>Em modo de demonstração, há um botão para simular o pagamento completo</li>
        </ul>
      </div>

      <PixPaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onPaymentSuccess={handlePaymentSuccess}
        user={mockUser}
      />
    </div>
  );
};

export default TestPixPaymentPage;
